<div class="qr">
  <h3 class="qr_title">Iniciá sesión con código QR</h3>
  <div class="qr_code">
    <qrcode
      colorDark="#262837"
      colorLight="#DEDBF4"
      [qrdata]="data.encodedToken"
      [width]="292"
      elementType="url"
      [errorCorrectionLevel]="'M'"
    >
    </qrcode>
    <div class="qr_code_image">
      <img src="assets/icons/logo_tc.png" />
    </div>
  </div>
  <p class="qr_description">
    Escanea este código con la
    <span (click)="goToApplication()">aplicación de TiendaCrypto</span> para iniciar sesión
  </p>
</div>
